import { combineReducers } from '@reduxjs/toolkit';
import { createReducer } from 'typesafe-actions';

import { updateLocation } from './actions';

export interface RouterState {
    pathname: string;
    search: string;
    hash: string;
}

const initialState: RouterState = {
    pathname: '/',
    search: '',
    hash: '',
};

export default combineReducers<RouterState>({
    pathname: createReducer(initialState.pathname).handleAction(
        updateLocation,
        (state, action) => action.payload.pathname
    ),
    search: createReducer(initialState.search).handleAction(
        updateLocation,
        (state, action) => action.payload.search
    ),
    hash: createReducer(initialState.hash).handleAction(
        updateLocation,
        (state, action) => action.payload.hash
    ),
});
